import { render, staticRenderFns } from "./OverviewLayout.vue?vue&type=template&id=5dff298a"
import script from "./OverviewLayout.vue?vue&type=script&lang=js"
export * from "./OverviewLayout.vue?vue&type=script&lang=js"
import style0 from "./OverviewLayout.vue?vue&type=style&index=0&id=5dff298a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports